'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ThresholdSliderDirective=class ThresholdSliderDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/thresholdSliderDirective/thresholdSliderTemplate'}
get objectBindings(){return['currentThreshold','newThreshold']}
get textBindings(){return['floor','ceiling']}
get controller(){return Controller}};let


Controller=class Controller{
static get $inject(){return['$scope','$element']}

constructor($scope,$element){

}};


module.exports=ThresholdSliderDirective;
//# sourceMappingURL=thresholdSliderDirective.js.map
